<template>
    <div class="fields selection" :class="{ checked: (current.times_id == time.id) }">
        <input type="radio" name="hourSelection" :id="time.id" :value="time.id" @click="updateAddons(time.id)"/>
        <label :for="time.id">
            <div class="checkbox">
            </div>

            <div class="title">
                {{ time.title }}
            </div>

            <span class="content">{{ time.description }}</span>
        </label>
    </div>
</template>

<script>
    Number.prototype.isOdd = function(num){
        return num % 2;
    }

    export default {
        props: ['time', 'base', 'current'],
        methods: {
            updateAddons: function (value) {
                this.$emit('updateaddons', value, this.time.price);
            }
        },
        watch: {
            "base.id": function () {
                this.$emit('updateaddons', this.base.times_id, this.time.price);
            }
        },
        computed: {
            priceChange: function() {
                var price = this.time.price;
                return (price >= 0 ? (price == 0 ? false :'+ £'+Math.abs(price)) : '- £'+Math.abs(price));
            }
        },
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// HourSelection.vue?13b17d0f